import VariantForm from "./VariantForm";

export default function CreateVariant() {
  return (
    <>
      <h3>Create Variant</h3>
      <VariantForm
        model={{ name: "" }}
        onSubmit={async (value) => {
          //when form is posted
          await new Promise((r) => setTimeout(r, 1));
          console.log(value);
        }}
      />
    </>
  );
}
